import { render } from "./GridStudies.vue?vue&type=template&id=4ac6c470&ts=true"
import script from "./GridStudies.vue?vue&type=script&lang=ts"
export * from "./GridStudies.vue?vue&type=script&lang=ts"

import "./GridStudies.vue?vue&type=style&index=0&id=4ac6c470&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__